module.exports = __webpack_public_path__ + "img/over-tip@3x.2b11f659.png";